var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.67 633.33C14.67 633.33 9.33 628 9.33 620C9.33 605.2 9.33 486.8 9.33 472C9.33 464 14.67 458.67 22.67 458.67C50.53 458.67 273.47 458.67 301.33 458.67C309.33 458.67 314.67 464 314.67 472C314.67 480 309.33 485.33 301.33 485.33C283.64 485.33 195.2 485.33 36 485.33L36 606.67C288.8 606.67 429.24 606.67 457.33 606.67C465.33 606.67 470.67 612 470.67 620C470.67 628 464 633.33 457.33 633.33C370.4 633.33 66.13 633.33 22.67 633.33Z",
    id: "d55dHvLmCh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33 560C81.33 560 76 554.67 76 546.67C76 538.67 81.33 533.33 89.33 533.33C97.33 533.33 161.33 533.33 169.33 533.33C177.33 533.33 182.67 538.67 182.67 546.67C182.67 553.33 177.33 560 169.33 560C153.33 560 97.33 560 89.33 560Z",
    id: "d2EX3nt14c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.67 406.67C14.67 406.67 9.33 401.33 9.33 393.33C9.33 378.67 9.33 261.33 9.33 246.67C9.33 238.67 14.67 233.33 22.67 233.33C66.13 233.33 413.87 233.33 457.33 233.33C465.33 233.33 470.67 238.67 470.67 246.67C470.67 252.8 470.67 301.87 470.67 308C470.67 316 465.33 321.33 457.33 321.33C449.33 321.33 444 316 444 308C444 304.8 444 288.8 444 260L36 260L36 381.33C206.4 381.33 301.07 381.33 320 381.33C328 381.33 333.33 386.67 333.33 394.67C333.33 401.33 328 406.67 320 406.67C260.53 406.67 52.4 406.67 22.67 406.67Z",
    id: "c374WjUjex"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33 333.33C81.33 333.33 76 328 76 320C76 312 81.33 306.67 89.33 306.67C97.33 306.67 161.33 306.67 169.33 306.67C177.33 306.67 182.67 312 182.67 320C182.67 328 177.33 333.33 169.33 333.33C153.33 333.33 97.33 333.33 89.33 333.33Z",
    id: "b1nOU3ftoR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.67 181.33C14.67 181.33 9.33 176 9.33 168C9.33 153.2 9.33 34.8 9.33 20C9.33 12 14.67 6.67 22.67 6.67C66.13 6.67 413.87 6.67 457.33 6.67C465.33 6.67 470.67 12 470.67 20C470.67 34.8 470.67 153.2 470.67 168C470.67 174.67 464 181.33 457.33 181.33C370.4 181.33 66.13 181.33 22.67 181.33ZM444 154.67L444 33.33L36 33.33L36 154.67L444 154.67Z",
    id: "a11w1lr09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33 106.67C81.33 106.67 76 101.33 76 93.33C76 85.33 81.33 80 89.33 80C97.33 80 161.33 80 169.33 80C177.33 80 182.67 85.33 182.67 93.33C182.67 101.33 177.33 106.67 169.33 106.67C153.33 106.67 97.33 106.67 89.33 106.67Z",
    id: "f4Wm40Y9J3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 73.33C356.95 73.33 348 82.29 348 93.33C348 104.38 356.95 113.33 368 113.33C379.05 113.33 388 104.38 388 93.33C388 82.29 379.05 73.33 368 73.33Z",
    id: "d3C98DjbjZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67 465.33C294.67 372 370.67 297.33 462.67 297.33C556 297.33 630.67 373.33 630.67 465.33C630.67 557.33 554.67 633.33 462.67 633.33C369.33 633.33 294.67 557.33 294.67 465.33ZM320 465.33C320 544 384 606.67 461.33 606.67C540 606.67 602.67 542.67 602.67 465.33C604 386.67 540 322.67 462.67 322.67C384 322.67 320 386.67 320 465.33Z",
    id: "a47u2eiyga"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 461.33C372 426.67 390.67 396 421.33 380C428 377.33 436 380 438.67 385.33C441.33 392 438.67 400 433.33 402.67C412 413.33 398.67 436 398.67 460C398.67 494.67 426.67 524 462.67 524C498.67 524 526.67 496 526.67 460C526.67 436 513.33 414.67 492 402.67C485.33 400 482.67 392 486.67 385.33C489.33 378.67 497.33 376 504 380C534.67 396 553.33 426.67 553.33 461.33C552 510.67 512 552 462.67 552C413.33 552 372 512 372 461.33Z",
    id: "a83iWry46A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.33 465.33C449.33 454.53 449.33 368.13 449.33 357.33C449.33 349.33 454.67 344 462.67 344C470.67 344 476 349.33 476 357.33C476 368.13 476 454.53 476 465.33C476 473.33 469.33 478.67 462.67 478.67C454.67 478.67 449.33 473.33 449.33 465.33Z",
    id: "f3vNBBE5vc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d55dHvLmCh",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d55dHvLmCh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2EX3nt14c",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2EX3nt14c",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c374WjUjex",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c374WjUjex",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1nOU3ftoR",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1nOU3ftoR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a11w1lr09z",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a11w1lr09z",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4Wm40Y9J3",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4Wm40Y9J3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3C98DjbjZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3C98DjbjZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a47u2eiyga",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a47u2eiyga",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a83iWry46A",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a83iWry46A",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f3vNBBE5vc",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f3vNBBE5vc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.21ab356ec3f740ccb6f5ae719fa7b291.svg";
export { ForwardRef as ReactComponent };